export const formDataToObject = (
  formData: FormData,
  filterOutKeys: string[] = [],
  convertCheckboxesToBoolean: boolean = true,
) => {
  const formValues: Record<string, string> = {};
  // Next.js invokes a server action with no FormData argument when it cannot
  // resolve the action id (E975, failed-to-find-server-action), so this is
  // reached with `formData` nullish or not a FormData despite the type.
  if (!(formData instanceof FormData)) return formValues;

  formData.forEach((value, key) => {
    if (filterOutKeys.find((k) => key.includes(k))) return;

    const v = value.toString();

    if (
      convertCheckboxesToBoolean &&
      key.toLowerCase().includes("checkbox") &&
      ["on", "off"].includes(v)
    ) {
      // "on" & "off" are not accepted by the Marketo API
      formValues[key] = v === "on" ? "true" : "false";
      return;
    }

    formValues[key] = v;
  });

  return formValues;
};
